import React, { useEffect } from "react";
import { connect } from "react-redux";
import Loader from "./../../../shared/loader";
import { fetchSetDressingsInScene } from "./ducks/actions";
import AddIcon from "../../icons/add";
import List from "./list";
import { Link } from "react-router-dom";

function ListSetDressingsContainer(props) {
  const { filmId, sceneId } = props.match.params;
  const { fetchSetDressingsInScene, loading, sceneSetDressings, errors, readOnly, sceneSettingId } = props;

  useEffect(() => {
    fetchSetDressingsInScene(filmId, sceneId);
  }, [filmId, sceneId]);

  function renderLoading() {
    return <Loader />;
  }

  function renderCharacters(sceneSetDressings, filmId, sceneId, sceneSettingId) {
    return (
      <div className="blade-menu">
        <List setDressings={sceneSetDressings} filmId={filmId} sceneId={sceneId} />
        {!readOnly && !window.location.pathname.endsWith("add") && <Link
          to={`/films/${filmId}/scenes/${sceneId}/set-dressings/add`}
          className="button is-transparent is-add">
          <AddIcon className="white-icon" />
          Assign Existing
        </Link>}
        {!readOnly && <Link
          to={{ pathname: `/films/${filmId}/set-dressings/add`, state: { sceneId, sceneSettingId, returnUrl: `/films/${filmId}/scenes/${sceneId}/set-dressings` } }}
          className="button is-transparent is-add">
          <AddIcon className="white-icon" />
          Add New
        </Link>}
      </div>
    );
  }

  return loading
    ? renderLoading()
    : renderCharacters(sceneSetDressings, filmId, sceneId, sceneSettingId);
}

function mapStateToSetDressings(state) {
  return {
    sceneSetDressings: state.scenesState.setDressingState.setDressings,
    sceneSettingId: state.scenesState.setDressingState.sceneSettingId,
    loading: state.scenesState.setDressingState.loading,
    errors: state.scenesState.setDressingState.errors,
    readOnly: state.scenesState.setDressingState.readOnly
  };
}

export default connect(mapStateToSetDressings, {
  fetchSetDressingsInScene
})(ListSetDressingsContainer);
